import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW1203Component } from './kymw1203.component';
import { GetOrderListService } from '../../../commons/kymw02/api-services/get-order-list.service';

/**
 * 一括設定画面 モジュール設定クラス
 *
 * @export KYMW4601Module
 * @class KYMW4601Module
 */
@NgModule({
  imports: [CommonModule, FormsModule, PlessSharedModule, AppCommonsModule],
  declarations: [KYMW1203Component],
  providers: [GetOrderListService],
})
export class KYMW1203Module {}
